import type { ApolloCache } from "@apollo/client";
import { insertIntoConnection, removeFromConnection } from "#app/lib/data/connection-cache-utils";

export function addIssueTypeToCache(cache: ApolloCache, issueType: any) {
  insertIntoConnection(cache, "issueTypes", "IssueTypeEdge", issueType);
}

export function removeIssueTypeFromCache(cache: ApolloCache, issueTypeId: string) {
  removeFromConnection(cache, "issueTypes", { __typename: "IssueType", issueTypeId });
}
